import React from 'react';
import Modal from '@mui/material/Modal';
import { useState } from 'react';
import { Button, Grid, Paper, TextField, Alert, InputLabel, Select, MenuItem, Box, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';
import { api_url } from '../config';
import ApiButtonComp from './api-button-comp';
import color from 'color'


const ModalComp = ({ tree_id, token, is_image1_uploaded, fetch, is_image2_uploaded, is_image3_uploaded, is_image4_uploaded, is_image5_uploaded }) => {

    const [visible, setVisible] = useState(false);
    const [month, setMonth] = useState('');
    const handler = () => setVisible(true);
    const [loader, setLoader] = useState(false);
    const [url1, setUrl1] = useState('');
    const [url2, setUrl2] = useState('');
    const [url3, setUrl3] = useState('');
    const [url4, setUrl4] = useState('');
    const [msg, setMsg] = useState(false);
    const [message, setMessage] = useState('');
    const closeHandler = () => {
        setVisible(false);
        console.log("closed");
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        // width: "18rem",
        bgcolor: 'background.paper',
        border: '2px solid #000',
        bradius: '5px',
        boxShadow: 24,
        p: 4,
    };

    // const handleUpload = async (event) => {
    //     try {
    //         // console.log(1);
    //         const { name } = event.target.files[0];

    //         console.log(tree_id);

    //         if (month.length === 0) {
    //             alert('Select Month');
    //             return false;
    //         }
    //         else {

    //             console.log(url1)
    //             console.log(url2)
    //             console.log(url3)
    //             console.log(url4)

    //             // const { data: data2 } = await axios({
    //             //     url: api_url + '/mission-vriksh-data-collection-1',
    //             //     method: 'post',
    //             //     responseType: 'json',
    //             //     data: {
    //             //         url: obj.url,
    //             //         tree_id: tree_id,
    //             //         token: token,
    //             //         month: month,
    //             //     },
    //             // })
    //             // if (data2.success == 'ok') {
    //             //     alert(data2.message);
    //             //     fetch()
    //             //     setMonth(null);
    //             //     setVisible(false);
    //             // } else {
    //             //     alert(data2.message);
    //             // }
    //         }

    //         //=======================================

    //     }
    //     catch (e) {
    //         alert(e.message);
    //     }
    //     finally {
    //         setLoader(false);
    //     }
    // }


    const handleUpload = async () => {
        try {
            setLoader(true);
            setMsg(false);
            if (url1 && url2 && url3) {
                const { data: data2 } = await axios({
                    url: api_url + '/mission-vriksh-data-collection-1',
                    method: 'post',
                    responseType: 'json',
                    data: {
                        url1: url1,
                        url2: url2,
                        url3: url3,
                        url4: url4,
                        tree_id: tree_id,
                        token: token,
                        month: month,
                    },
                })
                if (data2.success == 'ok') {
                    alert(data2.message);
                    fetch()
                    setMonth(null);
                    setVisible(false);
                } else {
                    alert(data2.message);
                }
            }
            else {
                setMessage("Please Upload Images")
                setMsg(true);
            }

        }
        catch (e) {
            alert(e.message);
        }
        finally {
            setLoader(false);
        }
    }





    return (
        <div>
            <Button style={{ color: '#7E9B24' }} fullWidth onClick={handler}><b>Upload</b></Button>

            {visible && <Modal
                open={visible}
                onClose={closeHandler}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Paper sx={style} style={{ padding: '27px', backgroundColor: 'seashell', borderRadius: '10px' }}>


                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            {loader && <Alert severity='success'>...Loading</Alert>}
                            {msg && <Alert severity='success'>{message}</Alert>}
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <InputLabel>Select Month</InputLabel>
                            <Select fullWidth value={month} onChange={(e) => setMonth(e.target.value)}>
                                <em>Select Age of Tree</em>
                                {is_image1_uploaded === 0 && <MenuItem value="0">0 month</MenuItem>}
                                {is_image2_uploaded === 0 && <MenuItem value="1">1 month</MenuItem>}
                                {is_image3_uploaded === 0 && <MenuItem value="3">3 months</MenuItem>}
                                {is_image4_uploaded === 0 && <MenuItem value="6">6 months</MenuItem>}
                                {is_image5_uploaded === 0 && <MenuItem value="9">9 months</MenuItem>}
                            </Select>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <ApiButtonComp title={"Front Image"} month={month} setState={setUrl1} id={"url-1"} setLoader={setLoader} setMessage={setMessage} setMsg={setMsg} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <ApiButtonComp title={"Left Image"} month={month} setState={setUrl2} id={"url-2"} setLoader={setLoader} setMessage={setMessage} setMsg={setMsg} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <ApiButtonComp title={"Right Image"} month={month} setState={setUrl3} id={"url-3"} setLoader={setLoader} setMessage={setMessage} setMsg={setMsg} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <ApiButtonComp title={"Top Image"} month={month} setState={setUrl4} id={"url-4"} setLoader={setLoader} setMessage={setMessage} setMsg={setMsg} />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Button style={{ backgroundColor: color('#7E9B24').lighten(1.2), color: '#b11116' }} fullWidth onClick={handleUpload}>Upload</Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Modal>}
        </div>
    )
}

export default ModalComp;
